export const BANKING_CARD_OFFERS = {
  BLUEVINE: 'bluevine',
  BANK_OF_AMERICA: 'bankOfAmerica',
  CHASE: 'chase'
};
